import {
  AnchoredDropdown,
  FieldButton,
  PopoverRow,
  RowMeta,
  RowName,
  SectionHeader,
  SectionLabel,
  SectionTag
} from '../../../components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ShareWithPicker = ({ options, selected, onChange }) => {
  const [open, setOpen] = useState(false),
    { t } = useTranslation();

  const current = selected || options[1];

  return (
    <div>
      <SectionHeader>
        <SectionLabel>03 — {t('add.shareWith')}</SectionLabel>
        <SectionTag>{t('common.required', 'Required')}</SectionTag>
      </SectionHeader>

      <AnchoredDropdown
        open={open}
        onClose={() => setOpen(false)}
        trigger={
          <FieldButton type="button" onClick={() => setOpen((v) => !v)}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="square"
              >
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18" />
                <path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18" />
              </svg>
              {current.value}
            </span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="square"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </FieldButton>
        }
        panel={options.map((opt) => (
          <PopoverRow
            key={opt.option}
            type="button"
            style={{ gridTemplateColumns: '1fr 20px' }}
            $selected={opt.option === current.option}
            onClick={() => {
              onChange(opt);
              setOpen(false);
            }}
          >
            <span style={{ minWidth: 0 }}>
              <RowName>{opt.value}</RowName>
              {opt.desc && <RowMeta>{opt.desc}</RowMeta>}
            </span>
            {opt.option === current.option && (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3.5"
                strokeLinecap="square"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            )}
          </PopoverRow>
        ))}
      />
    </div>
  );
};

export default ShareWithPicker;
